import { forwardRef } from 'react';
import Input, { InputProps } from '../Input';

interface FormInputProps extends InputProps {}

const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ children, className = '', ...rest }, ref) => {
    return (
      <Input ref={ref} className={`form-input ${className}`} {...rest}>
        {children}
      </Input>
    );
  },
);

export default Object.assign(FormInput, {
  ...Input,
});
